import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { withRouteData } from 'react-static';
import Waypoint from 'react-waypoint';
import throttle from 'lodash.throttle';

import CondensedHeader from './CondensedHeader';
import Page from '../global/Page';
import ProductHeader from './ProductHeader';
import ProductSections from './ProductSections';
import ProductCta from './ProductSections/ProductCta';

const StyledPage = styled(Page)`
  background-color: ${p => p.theme.color.tertiary};
`;

class Product extends React.Component {
  state = {
    show: null,
    showCondensed: false
  };

  showHideHeaders = event => {
    this.setState({
      showCondensed: event.currentPosition === 'above'
    });
  };

  setShow = () => {
    this.setState(({ show }) => {
      const { innerWidth: width } = window;
      if (show !== 'tabs' && width > 1024) return { show: 'tabs' };
      if (show !== 'accordion' && width <= 1024) return { show: 'accordion' };
    });
  };

  componentDidMount() {
    if (typeof window === 'undefined') return;

    this.listener = throttle(this.setShow, 100);
    window.addEventListener('resize', this.listener);
    this.setShow();
  }

  get sections() {
    const sections = Array.from(this.props.product.sections) || [];
    const shouldPrepend =
      this.props.customContent &&
      ((sections.length > 0 && sections[0].id !== 'custom') ||
        sections.length === 0);

    if (shouldPrepend) {
      sections.unshift({
        data: this.props.customContent,
        id: 'custom',
        label: 'Product Features'
      });
    }

    return sections;
  }

  hasLiteratureSection(sections) {
    return sections && sections.filter(s => s.id === 'lit').length > 0;
  }

  render() {
    const { product } = this.props;
    const { seo } = product;
    const { show, showCondensed } = this.state;

    let hasCustomTank = false;
    let customTankIndex = -1;

    if (
      this.sections &&
      this.sections.length > 0 &&
      this.sections[0]?.data?.literature &&
      this.sections[0]?.data?.literature.length > 0
    ) {
      customTankIndex = this.sections[0]?.data.literature[0].findIndex(
        lit => lit.categoryName === 'Custom Tank Quotations'
      );

      hasCustomTank =
        customTankIndex > -1 && product.slug !== 'hot-water-generator';
    }

    return (
      <StyledPage>
        <Helmet
          title={seo ? `${seo.title} | ${product.name}` : product.name}
          meta={[
            { property: 'og:title', content: 'Product' },
            {
              property: 'description',
              content: seo ? seo.description : product.description
            }
          ]}
        >
          {product.models.map((m, i) => (
            <meta
              key={product.slug}
              className="swiftype"
              name="modelNumberStr"
              data-type="string"
              content={m.model}
            />
          ))}
        </Helmet>
        <CondensedHeader
          productCategory={product.categoryTree[0]}
          productName={product.name}
          show={showCondensed}
        />
        <ProductHeader
          archived={product.archived}
          breadCrumbs={product.categoryTree}
          models={product.models}
          productDescription={product.description}
          productFeatures={product.features}
          productImage={product.image}
          productName={product.name}
          productNameHighlight={product.nameHighlight}
          showDocsButton={this.hasLiteratureSection(product.sections)}
          showCustomTankButton={hasCustomTank}
          threeDModelUrl={this.props.threeDModelUrl}
        />
        {product.landingPageSlug && (
          <ProductCta
            landingPageSlug={product.landingPageSlug}
            productName={product.name}
          />
        )}
        <Waypoint
          onPositionChange={this.showHideHeaders}
          scrollableAncestor="window"
          topOffset="133px"
        />
        <ProductSections
          productSlug={product.slug}
          sections={this.sections}
          show={show}
        />
      </StyledPage>
    );
  }
}

Product.propTypes = {
  customContent: PropTypes.element,
  product: PropTypes.object,
  threeDModelUrl: PropTypes.string
};

export default withRouteData(Product);
